// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientPointsReport = createAction('SET_PATIENT_POINTS_REPORT')
export const setPatientPointsReportLoading = createAction(
  'SET_PATIENT_POINTS_REPORT_LOADING'
)
